import { useMemo, useState } from "react";
import classNames from "classnames";
import { ProductIcon } from "segments/desktop/pricing/icons/product-icon";
import { DARK_THEME } from "components/enhancements/tooltip/tooltip-constants";
import TooltipComponent from "components/enhancements/tooltip/tooltip-component";
import {
  PRICING_PAGE_PRODUCT_SWITCHER_TOOLTIP_SHOWN,
  PRICING_PAGE_PRODUCT_SWITCHER_TOOLTIP_HIDDEN
} from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { productSwitcher } from "./product-switcher.scss";

export const ProductSwitcher = ({ onProductChange, selectedProduct, config, translate }) => {
  const [hideTooltip, setHideTooltip] = useState(false);

  const products = useMemo(() => {
    const ans = [];
    Object.entries(config).map(([key, value]) => {
      if (value.showInSwitcher) {
        ans.push({
          id: key,
          label: value.switcherLabel,
          color: value.switcherIconColor,
          iconName: `${key}White`,
          order: value.orderInSwitcher,
          tooltipLabelKey: value.switcherTooltipLabelKey
        });
      }
    });

    ans.sort((a, b) => a.order - b.order);
    return ans;
  }, [config]);

  const onMouseEnter = (productIdHovered) => {
    trackEvent(PRICING_PAGE_PRODUCT_SWITCHER_TOOLTIP_SHOWN, {
      info1: selectedProduct,
      info2: productIdHovered,
      productKind: selectedProduct
    });
  };
  const onMouseLeave = (productIdHovered) => {
    setHideTooltip(false);
    tackOnTooltipHidden(productIdHovered);
  };

  const tackOnTooltipHidden = (productIdHovered) => {
    trackEvent(PRICING_PAGE_PRODUCT_SWITCHER_TOOLTIP_HIDDEN, {
      info1: selectedProduct,
      info2: productIdHovered,
      productKind: selectedProduct
    });
  }
  const onProductSwitch = (productId) => {
    if (productId !== selectedProduct) {
      setHideTooltip(true);
      tackOnTooltipHidden(productId);
    }

    onProductChange(productId);
  };

  return (
    <div className="switcher-container">
      {products.map((product) => (
        <div
          className={classNames("product-item", { "is-selected-product": selectedProduct === product.id })}
          onMouseEnter={() => onMouseEnter(product.id)}
          onMouseLeave={() => onMouseLeave(product.id)}
        >
          <button
            style={{ "--switcher-color": product.color }}
            key={product.id}
            type="button"
            className="product-button"
            onClick={() => {
              onProductSwitch(product.id);
            }}
          >
            <div className={classNames("icon-container", { "is-selected-product": selectedProduct === product.id })}>
              <div className={classNames("product-icon", { "is-selected-product": selectedProduct === product.id })}>
                <ProductIcon product={product.iconName} />
              </div>
            </div>
            <div className={classNames("product-label", { "is-selected-product": selectedProduct === product.id })}>
              {product.label}
              <div className="tooltip">
                {!hideTooltip && (
                  <TooltipComponent theme={DARK_THEME} className="floating-tooltip">
                    {translate(product.tooltipLabelKey)}
                  </TooltipComponent>
                )}
              </div>
            </div>
          </button>
        </div>
      ))}
      <style jsx>{productSwitcher}</style>
    </div>
  );
};
